export default "__VITE_ASSET__BJOc$p2h__"